import WorkType from "@/models/Shared/WorkType";

export default class CreateWorkerPositionRequest {
    positionId: string;
    status: number;
    payRate: number;
    workTypes: WorkType[];
    source: number;
}